import React, { useEffect, useRef, useState } from "react";
import { facturaAPI, toolsAPI } from "../../../utils/funcionesAPI";
import {
  getLocalidadesPorPartido,
  getPartidosPorProvincia,
  manejadorDeRespuesta,
} from "../../../utils/Tools";
import { toast } from "react-toastify";
import get from "../../../utils/get";
import SelectorDireccionesFactura from "../../Global/SelectorDireccionesFactura";

const ModalFactura = (props) => {
  //FC: creo la ref al boton dentro del modal, que al hacer click dispara el trigger para levantar el modal
  const formularioDefault = {
    id: 0,
    responsabilidad: "",
    tipoDocumento: { sigla: "" },
    numeroDocumento: "",
    factura: "",
    razonSocial: "",
    calle: "",
    altura: "",
    codigoPostal: "",
    mail: "",
    provincia: { codigo: "ARC", denominacion: "Capital Federal" },
    partido: { id: 0, codigo: "" },
    localidad: { id: "5001", denominacion: "Ciudad Autónoma De Buenos Aires" },
    numeroReserva: props.numeroReserva,
    esPropia: 0,
  };

  const myRefname = useRef(null);
  const [habilitarBoton, setHabilitarBoton] = useState("ok");
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [partidos, setPartidos] = useState([]);
  const [localidades, setLocalidades] = useState([]);
  const [deshabilitarTipoDocumento, setDeshabilitarTipoDocumento] =
    useState(true);
  const [deshabilitarFactura, setDeshabilitarFactura] = useState(true);
  const [mostrarInputsOcultos, setMostrarInputsOcultos] = useState(2);
  const [formulario, setFormulario] = useState(formularioDefault);

  const [formularioSeleccionado, setFormularioSeleccionado] = useState({
    id: 0,
    provincia: { id: 2, codigo: "ARC", denominacion: "Capital Federal" },
    partido: {
      id: 198,
      codigo: "198",
      denominacion: "CIUDAD AUTONOMA DE BUENOS AIRES",
    },
  });
  const [
    mostrarListadoDeDatosDeFacturacionPrevios,
    setMostrarListadoDeDatosDeFacturacion,
  ] = useState("true");
  const tipoCliente = sessionStorage.getItem("tipoCliente");

  /*
  const getLocalidadesPorProvincia = (codigoProvincia) => {
    const data = JSON.stringify({ accion: "localidades", codigoProvincia });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setLocalidades(respuesta.data);
    });
  };
*/

  const getDatosDeFacturacionPropio = () => {
    const token = sessionStorage.getItem("token");
    const data = JSON.stringify({
      accion: "traerDatosDeFacturacionDelCliente",
      token,
    });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        handleProvinciaChange({
          target: { value: get(respuesta, "data.provincia.codigo") },
        });
        setFormulario(respuesta.data);
      }
    });
  };

  useEffect(() => {
    let data = JSON.stringify({ accion: "tiposDeDocumento" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setTiposDocumento(respuesta.data);
    });

    data = JSON.stringify({ accion: "provincias" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) setProvincias(respuesta.data);
    });

    //getLocalidadesPorProvincia("ARC");
    myRefname.current.click();
  }, []);

  useEffect(() => {
    getPartidosPorProvincia(
      formularioSeleccionado.provincia.codigo,
      setPartidos,
    );
  }, [formularioSeleccionado.provincia.id]);

  const handelChangeFormulario = (e) => {
    //console.log(e.target.value);
    let formularioClone = Object.assign({}, formulario);
    formularioClone[e.target.name] = e.target.value;
    //FC: si es tipo de cliente valido los tipo de documento permitidos
    let deshabilitarTipoDocumentoClone = deshabilitarTipoDocumento;
    let deshabilitarFacturaClone = deshabilitarFactura;
    if (e.target.name === "responsabilidad") {
      if (e.target.value === "CFI") {
        formularioClone.tipoDocumento = { sigla: "DNI" };
        deshabilitarTipoDocumentoClone = true;
        deshabilitarFacturaClone = false;
        formularioClone.factura = "FACB";
      } else if (e.target.value === "MON") {
        formularioClone.tipoDocumento = { sigla: "CUIT" };
        deshabilitarTipoDocumentoClone = true;
        deshabilitarFacturaClone = false;
        formularioClone.factura = "FACB";
      } else {
        deshabilitarTipoDocumentoClone = true;
        formularioClone.tipoDocumento = { sigla: "CUIT" };
        if (e.target.value === "RIN") {
          formularioClone.factura = "FACA";
          deshabilitarFacturaClone = true;
        } else {
          deshabilitarFacturaClone = false;
        }
      }
    }

    setFormulario(formularioClone);
    setDeshabilitarFactura(deshabilitarFacturaClone);
    setDeshabilitarTipoDocumento(deshabilitarTipoDocumentoClone);
  };

  const handleTipoDocumentoChange = (e) => {
    const sigla = e.target.value;
    const tipoDocumentoEncontrado = tiposDocumento.find(
      (e) => e.sigla === sigla,
    );
    let formularioClone = Object.assign({}, formulario);
    formularioClone.tipoDocumento = tipoDocumentoEncontrado;
    setFormulario(formularioClone);
  };

  const handleProvinciaChange = (e) => {
    const codigoProv = e.target.value;
    const provinciaEncontrado = provincias.find((e) => e.codigo === codigoProv);
    let formularioClone = Object.assign({}, formulario);
    formularioClone.localidad = { id: 0 };
    formularioClone.provincia = provinciaEncontrado || { codigo: 0 };
    setFormulario(formularioClone);
    getPartidosPorProvincia(codigoProv, setPartidos);
    //getLocalidadesPorProvincia(codigoProv);
  };

  const handlePartidoChange = (e) => {
    const partido = partidos.find((part) => part.id === e.target.value) || {
      codigo: "0",
      id: "0",
    };

    let formularioClone = Object.assign({}, formulario);
    formularioClone.localidad = { id: 0 };
    formularioClone.partido = partido;
    setFormulario(formularioClone);

    getLocalidadesPorPartido(partido.codigo, setLocalidades);
  };

  const handleLocalidadChange = (e) => {
    const idLocalidad = e.target.value;
    const localidadEncontrada = localidades.find((e) => e.id === idLocalidad);
    let formularioClone = Object.assign({}, formulario);
    formularioClone.localidad = localidadEncontrada || { id: 0 };
    setFormulario(formularioClone);
  };

  const handleGuardarFormularioClick = (e) => {
    e.preventDefault();
    const token = sessionStorage.getItem("token");

    if (
      tipoCliente === "IND" &&
      mostrarListadoDeDatosDeFacturacionPrevios === "true" &&
      !formulario.id
    ) {
      toast.error("No ha seleccionado un dato de facturacion.", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (
      tipoCliente !== "IND" ||
      (tipoCliente === "IND" &&
        mostrarListadoDeDatosDeFacturacionPrevios === "false")
    ) {
      if (
        formulario.razonSocial === "" ||
        !formulario.razonSocial ||
        !formulario.calle ||
        formulario.calle === "" ||
        formulario.altura === "" ||
        !formulario.altura ||
        formulario.codigoPostal === "" ||
        !formulario.codigoPostal ||
        formulario.provincia.codigo === 0 ||
        formulario.provincia.codigo === "" ||
        formulario.localidad.id === 0 ||
        formulario.localidad.id === "" ||
        formulario.numeroDocumento === "" ||
        formulario.factura === "" ||
        formulario.tipoDocumento.sigla === "" ||
        formulario.tipoDocumento.sigla === "0" ||
        formulario.responsabilidad === "" ||
        formulario.responsabilidad === "0"
      ) {
        toast.info("Debe completar todos los campos", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        return false;
      }
      if (formulario.calle.length < 5) {
        toast.info("La calle debe tener al menos 5 caracteres", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        return false;
      }
      if (formulario.razonSocial.trim().length < 2) {
        toast.info("Debe escribir al menos 2 caracteres para la Razon Social", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        return false;
      }
    }

    // aca entiendo que uso el esPropia del default mas arriba, que es uno, asi le llega al back
    //formularioDefault = Object.assign({}, formulario);

    setHabilitarBoton("");

    const form = document.getElementById("formPDF");
    const formData = new FormData(form);
    formData.append("accion", "solicitarFactura");
    formData.append("canal", "WEB");
    formData.append("token", token);
    formulario.numeroReserva = props.numeroReserva;
    formulario.esPropia = tipoCliente === "IND" ? 1 : formulario.esPropia;
    formData.append("formulario", JSON.stringify(formulario));
    /*
    const data = JSON.stringify({
      accion: "solicitarFactura",
      formulario: formularioDefault,
      token: token
    });
*/
    facturaAPI(formData).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        toast.success(respuesta.data, {
          position: toast.POSITION.BOTTOM_CENTER,
          onClose: () => window.location.reload(),
        });
        setHabilitarBoton("ok");
        //props.onClickBotonFactura();
        //props.onCancelarClick();
        //handleCancelarFormularioClick();
        //document.getElementById("formPDF").reset();
      }
    });
  };

  const handleCancelarFormularioClick = (e) => {
    props.onCancelarClick();
  };

  const handleMostrarInputsChange = (e) => {
    setFormulario(formularioDefault);
    setMostrarInputsOcultos(Number(e.target.value));
    if (Number(e.target.value) === 1) {
      getDatosDeFacturacionPropio();
    }
  };

  const handleMostrarListadoDeDatosDeFacturacionChange = (e) => {
    setMostrarListadoDeDatosDeFacturacion(e.target.value);
    setFormulario(formularioDefault);
  };

  return (
    <div id="loader" className="loader result">
      <button
        ref={myRefname}
        type="button"
        style={{ display: "none" }}
        className="btn btn-primary"
        data-toggle="modal"
        data-target="#exampleModalCenter"
      >
        Launch demo modal
      </button>

      <div
        className="modal fade bd-example-modal-lg"
        id="exampleModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Formulario de Factura
              </h5>
              <button
                type="button"
                onClick={handleCancelarFormularioClick}
                style={{ color: "#fff", opacity: "1", textShadow: "none" }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {tipoCliente !== "IND" && (
                <div className="form-group d-inline-block text-left col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <p>Marcar la opción deseada</p>
                  <input
                    className="checkRegistracion"
                    type="radio"
                    value="1"
                    name="radio"
                    checked={mostrarInputsOcultos === 1}
                    onChange={handleMostrarInputsChange}
                  />{" "}
                  La factura es a nombre mio
                  <br />
                  <input
                    className="checkRegistracion"
                    type="radio"
                    value="2"
                    name="radio"
                    checked={mostrarInputsOcultos === 2}
                    onChange={handleMostrarInputsChange}
                  />{" "}
                  La factura es para otro cliente (se le solicitarán datos del
                  cliente)
                </div>
              )}

              {tipoCliente === "IND" && (
                <div className="form-group d-inline-block text-left col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <input
                    className="checkRegistracion"
                    type="radio"
                    value="true"
                    name="radioMostrarListado"
                    checked={
                      mostrarListadoDeDatosDeFacturacionPrevios === "true"
                    }
                    onChange={handleMostrarListadoDeDatosDeFacturacionChange}
                  />{" "}
                  Deseo usar datos de facturacion cargados anteriormente
                  <br />
                  <input
                    className="checkRegistracion"
                    type="radio"
                    value="false"
                    name="radioMostrarListado"
                    checked={
                      mostrarListadoDeDatosDeFacturacionPrevios === "false"
                    }
                    onChange={handleMostrarListadoDeDatosDeFacturacionChange}
                  />{" "}
                  Deseo agregar nuevos datos de facturacion
                </div>
              )}
              {tipoCliente === "IND" &&
                mostrarListadoDeDatosDeFacturacionPrevios === "true" && (
                  <SelectorDireccionesFactura
                    formularioSeleccionado={formularioSeleccionado}
                    setFormulario={setFormulario}
                    setFormularioSeleccionado={setFormularioSeleccionado}
                  />
                )}

              {((tipoCliente === "IND" &&
                mostrarListadoDeDatosDeFacturacionPrevios === "false") ||
                tipoCliente !== "IND") && (
                <div>
                  <h6 className="text-left">
                    Complete el Formulario para solicitar una Factura
                  </h6>
                  <p className="text-left" style={{ fontSize: "0.8rem" }}>
                    Todos los campos son obligatorios y recuerde ingresar los
                    datos tal como quiere que figuren en la factura. No usar
                    apodos, sobrenombres o abreviaturas, solo nombre y apellido
                    completo o razon social, sino{" "}
                    <span style={{ color: "red" }}>
                      {" "}
                      no tomaremos como valida la solicitud de factura.
                    </span>
                    <br />
                    {mostrarInputsOcultos === 1 && (
                      <span>
                        Los datos mostrados son los que figuran en su ficha. En
                        caso de ver errores o desear cambiar alguno, por favor
                        contacte a su vendendor.
                      </span>
                    )}
                  </p>
                  <form
                    id="solicitarFactura"
                    action="#"
                    method="post"
                    className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 row"
                  >
                    <label
                      style={{ marginTop: "5px" }}
                      className="labelPerfil  text-left"
                      htmlFor="responsabilidad"
                    >
                      Categoria
                    </label>
                    <div className="input-group">
                      <select
                        name="responsabilidad"
                        className="custom-select"
                        value={formulario.responsabilidad}
                        onChange={handelChangeFormulario}
                      >
                        <option value="0">Seleccione una categoria</option>
                        <option value="RIN">Responsable Inscripto</option>
                        <option value="MON">Monotributo</option>
                        <option value="EXE">Exento</option>
                        <option value="CFI">Consumidor Final</option>
                      </select>
                    </div>

                    <label
                      style={{ marginTop: "5px" }}
                      className="labelPerfil text-left"
                      htmlFor="tipoDocumento"
                    >
                      Tipo Documento
                    </label>
                    <div className="input-group">
                      <select
                        name="tipoDocumento"
                        className="custom-select"
                        onChange={handleTipoDocumentoChange}
                        disabled={deshabilitarTipoDocumento}
                        value={formulario.tipoDocumento.sigla}
                      >
                        <option value="0">Seleccione un documento</option>
                        {tiposDocumento.map((tipoDeDocumento) => {
                          return (
                            <option
                              key={tipoDeDocumento.idTipoDocumento}
                              value={tipoDeDocumento.sigla}
                            >
                              {tipoDeDocumento.denominacion}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <label
                      style={{ marginTop: "5px" }}
                      className="labelPerfil  text-left"
                      htmlFor="responsabilidad"
                    >
                      Responsabilidad
                    </label>
                    <div className="input-group">
                      <select
                        name="factura"
                        className="custom-select"
                        value={formulario.factura}
                        disabled={deshabilitarFactura}
                        onChange={handelChangeFormulario}
                      >
                        {formulario.responsabilidad === "CFI" ||
                        formulario.responsabilidad === "MON" ? null : (
                          <option value="FACA">Factura A</option>
                        )}
                        <option value="FACB">Factura B</option>
                      </select>
                    </div>

                    <div
                      className="form-group d-inline-block col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                      style={{ padding: "0" }}
                    >
                      <label
                        style={{ marginTop: "5px" }}
                        className="labelPerfil text-left"
                        htmlFor="numeroDocumento"
                      >
                        {formulario.tipoDocumento.sigla !== "CUIT"
                          ? "N° Documento"
                          : "CUIT/CUIL (sin guiones)"}
                      </label>
                      <input
                        value={formulario.numeroDocumento}
                        name="numeroDocumento"
                        placeholder="Número"
                        type="number"
                        className="form-control"
                        onChange={handelChangeFormulario}
                      />
                    </div>

                    <div className="form-group d-inline-block col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                      <label
                        style={{ marginTop: "5px" }}
                        className="labelPerfil text-left"
                        htmlFor="razonSocial"
                      >
                        Nombre y Apellido Completo / Razon Social
                      </label>
                      <input
                        type="text"
                        value={formulario.razonSocial}
                        name="razonSocial"
                        placeholder="Nombre completo / Razon Social"
                        className="form-control"
                        onChange={handelChangeFormulario}
                      />
                    </div>

                    <div
                      className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                      style={{ padding: "0" }}
                    >
                      <label
                        style={{ marginTop: "5px" }}
                        className="labelPerfil text-left "
                        htmlFor="calle"
                      >
                        Calle
                      </label>
                      <input
                        value={formulario.calle}
                        name="calle"
                        placeholder="Calle"
                        type="text"
                        className="form-control"
                        onChange={handelChangeFormulario}
                      />
                    </div>

                    <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label
                        style={{ marginTop: "5px" }}
                        className="labelPerfil text-left "
                        htmlFor="altura"
                      >
                        Altura
                      </label>
                      <input
                        value={formulario.altura}
                        name="altura"
                        placeholder="Numero"
                        type="text"
                        className="form-control"
                        onChange={handelChangeFormulario}
                      />
                    </div>

                    <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label
                        style={{ marginTop: "5px" }}
                        className="labelPerfil text-left "
                        htmlFor="codigoPostal"
                      >
                        Cod. Postal
                      </label>
                      <input
                        value={formulario.codigoPostal}
                        name="codigoPostal"
                        placeholder="C.P."
                        type="text"
                        className="form-control"
                        onChange={handelChangeFormulario}
                      />
                    </div>

                    <div
                      className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                      style={{ padding: "0" }}
                    >
                      <label
                        className="labelPerfil text-left "
                        htmlFor="provincia"
                      >
                        Provincia *
                      </label>
                      <select
                        className="form-control"
                        name="provincia"
                        onChange={handleProvinciaChange}
                        value={formulario.provincia.codigo}
                      >
                        <option value="0">Provincia</option>
                        {provincias.map((provincia) => {
                          return (
                            <option key={provincia.id} value={provincia.codigo}>
                              {provincia.denominacion}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="labelForm" htmlFor="partido">
                        Partido *
                      </label>
                      <select
                        className="form-control"
                        name="partido"
                        onChange={handlePartidoChange}
                        value={formulario.partido.id}
                      >
                        <option value="0">Partido</option>
                        {partidos.map((partido) => {
                          return (
                            <option key={partido.id} value={partido.id}>
                              {partido.denominacion}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label
                        className="labelPerfil text-left "
                        htmlFor="localidades"
                      >
                        Localidad *
                      </label>
                      <select
                        className="form-control"
                        name="localidades"
                        onChange={handleLocalidadChange}
                        value={formulario.localidad.id}
                      >
                        <option value="0">Localidad</option>
                        {localidades.map((localidad) => {
                          return (
                            <option key={localidad.id} value={localidad.id}>
                              {localidad.denominacion}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    {tipoCliente === "IND" && (
                      <div
                        className="form-group d-inline-block col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                        style={{ padding: "0" }}
                      >
                        <label
                          style={{ marginTop: "5px" }}
                          className="labelPerfil text-left "
                          htmlFor="codigoPostal"
                        >
                          Email
                        </label>
                        <input
                          value={formulario.mail}
                          name="mail"
                          placeholder="Email"
                          type="text"
                          className="form-control"
                          onChange={handelChangeFormulario}
                        />
                      </div>
                    )}
                  </form>
                </div>
              )}
              <form
                style={{
                  display:
                    tipoCliente !== "IND" && mostrarInputsOcultos === 2
                      ? "block"
                      : "none",
                }}
                id="formPDF"
              >
                <div className="form-group d-inline-block col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <label className="labelPerfil text-left " htmlFor="archivo">
                    Adjuntar PDF *
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    name="archivo"
                    placeholder="PDF"
                    accept="application/pdf"
                  />
                </div>
              </form>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                onClick={handleCancelarFormularioClick}
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={handleGuardarFormularioClick}
                className="btn btn-primary"
                disabled={!habilitarBoton}
              >
                Solicitar Factura
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalFactura;



// WEBPACK FOOTER //
// ./src/components/MisReservas/ListadoReservas/ModalFactura.js